<template>
    <v-main class="main" :class="{ 'meter-background': $route.name === 'MeterMenu' || $route.name === 'Meter' }">
        <div class="content">
            <Notification v-if="is_logged_user && projectExists" />
            <v-fade-transition mode="out-in">
                <router-view />
            </v-fade-transition>
        </div>
    </v-main>
</template>

<script>
import { mapState } from 'vuex'
import Notification from '@/components/core/Notification'
export default {
    name: 'ContentView',
    components: { Notification },
    computed: {
        ...mapState({
            is_logged_user: (state) => state.authentication.status.loggedIn,
            projectExists: (state) => state.project.nameEui !== null,
        }),
    },
}
</script>

<style scoped>
.main {
    min-height: 100vh;
}
.meter-background {
    background-color: #f3f7f6;
}
.content {
    height: 100%;
}
</style>
